"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.integer = void 0;

var Converters_1 = require("../check/arbitrary/definition/Converters");

var IntegerArbitrary_1 = require("./_internals/IntegerArbitrary");

function buildCompleteIntegerConstraints(constraints) {
  var min = constraints.min !== undefined ? constraints.min : -0x80000000;
  var max = constraints.max !== undefined ? constraints.max : 0x7fffffff;
  return {
    min: min,
    max: max
  };
}

function extractIntegerConstraints(args) {
  if (args[0] === undefined) {
    return {};
  }

  if (args[1] === undefined) {
    var _sargs = args;
    if (typeof _sargs[0] === 'number') return {
      max: _sargs[0]
    };
    return _sargs[0];
  }

  var sargs = args;
  return {
    min: sargs[0],
    max: sargs[1]
  };
}

function integer() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var constraints = buildCompleteIntegerConstraints(extractIntegerConstraints(args));

  if (constraints.min > constraints.max) {
    throw new Error('fc.integer maximum value should be equal or greater than the minimum one');
  }

  if (!Number.isInteger(constraints.min)) {
    throw new Error('fc.integer minimum value should be an integer');
  }

  if (!Number.isInteger(constraints.max)) {
    throw new Error('fc.integer maximum value should be an integer');
  }

  var arb = new IntegerArbitrary_1.IntegerArbitrary(constraints.min, constraints.max);
  return (0, Converters_1.convertFromNextWithShrunkOnce)(arb, arb.defaultTarget());
}

exports.integer = integer;